<template>
  <div class="d-flex-column justify-start align-start gap-10">
    <MobileToc v-if="$isMobile()" :blog="blog"/>
    <div class="d-flex-column justify-start align-start blog_detail_page">
      <BlogTitle :blog="blog" v-if="blog" />
      <div class="blog_main_layout" id="blog_main_layout">
        <!-- <BlogLeftsidebar /> -->
        <ClientOnly>
          <BlogContent :blog="blog" />
        </ClientOnly>
        <BlogRightsidebar :blog="blog" v-if="!$isMobile()" />
      </div>
    </div>
  </div>
</template>

<script setup>
import BlogLeftsidebar from "./BlogLeftsidebar.vue";
import BlogRightsidebar from "./BlogRightsidebar.vue";
import sanityClient from "~/lib/sanityClient";
import BlogContent from "./BlogContent.vue";
import BlogTitle from "./BlogTitle.vue";
import MobileToc from "./MobileToc.vue";
const blog = ref();
const router = useRouter();
const route = router.currentRoute;

const routeSlug = computed(() => {
  let slug = router.currentRoute.value.params?.blogSlug;
  if (Array.isArray(slug)) {
    return slug[0];
  }
  return slug || "";
});
const fetchData = async () => {
  try {
    let blogSlug = routeSlug.value;
    const query = `*[_type == "blog" && slug.current == $slug][0]{
  _id,
  title,
  slug,
  description,
  metaTitle,
  metaDescription,
  chipColor,
 content[]{
        ...,
        asset-> { url } // Ensure images inside content have their URL
      },
  created_at,
  gametitle,
  blogAuthor,
  coverImage {
  asset -> {
      _id,
        url
          }
        }
    }`;

    const params = { slug: blogSlug };
    const blogPost = await sanityClient.fetch(query, params);
    if (blogPost) {
      blog.value = blogPost;
      // console.log(blogPost);
    } else {
      console.log("Blog not found");
    }
  } catch (error) {
    console.log(error);
  }
};

const navToEl = () => {
  const query = route.value.query?.navto;
  if (query) {
    const el = document.getElementById(query);
    if (el) {
      el.scrollIntoView({
        block: "center",
      });
    }
  }
};

await fetchData();

onNuxtReady(async () => {
  navToEl();
});
watch(
  () => route.value.query?.navto,
  () => {
    navToEl();
  }
);
</script>

<style lang="scss">
@import "../../assets/scss/modules/blog.scss";
</style>
